function cardRuImages() {
  const allCards = document.querySelectorAll(`.card-wrapper-RU`);
  if (allCards.length > 0) {
    allCards.forEach((card) => {
      let allImgs = card.querySelectorAll(`img.motion-reduce`);
      let allThumbnails = card.querySelectorAll(
        `.thumbnail-list__item .thumbnail`,
      );
      allThumbnails.forEach((thumb) => {
        thumb.addEventListener("mouseenter", (e) => {
          allThumbnails.forEach((otherThumb) => {
            if (otherThumb !== thumb) {
              otherThumb.removeAttribute("aria-current");
            }
          });
          allImgs.forEach((elemento) => {
            if (elemento.dataset.thumb === thumb.dataset.cardImg) {
              elemento.classList.add("show-image");
              thumb.setAttribute("aria-current", "true");
            } else {
              elemento.classList.remove("show-image");
            }
          });
        });
      });
    });
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  cardRuImages();
});
